import { init, locale, register } from 'svelte-i18n';
export class LocalizationService {
    constructor(pathname, translationRemoteRepository, uiConfig) {
        this.pathname = pathname;
        this.translationRemoteRepository = translationRemoteRepository;
        this.uiConfig = uiConfig;
    }
    async configure() {
        init({
            fallbackLocale: LocalizationService.FALLBACK_LOCALE,
            initialLocale: this.getCurrentLocaleFromUrl(),
            warnOnMissingMessages: false
        });
        await this.registerLoaders();
        this.pathname.subscribe((_pathname) => {
            const localeFromUrl = this.getCurrentLocaleFromUrl();
            locale.set(localeFromUrl || LocalizationService.FALLBACK_LOCALE);
        });
    }
    async registerLoaders() {
        this.registerLoader(LocalizationService.FALLBACK_LOCALE);
        this.registerLoader(LocalizationService.XX_LOCALE);
        for (let enabledLocale of this.uiConfig.locales) {
            if (enabledLocale !== LocalizationService.FALLBACK_LOCALE && enabledLocale !== LocalizationService.XX_LOCALE) {
                this.registerLoader(enabledLocale);
            }
        }
    }
    registerLoader(enabledLocale) {
        register(enabledLocale, () => this.translationRemoteRepository.getTranslations(enabledLocale));
    }
    getCurrentLocaleFromUrl() {
        var _a;
        return (_a = window.location.hash.match(/^#\/([a-zA-Z\-]+)/)) === null || _a === void 0 ? void 0 : _a[1];
    }
    static getLanguageText(locale) {
        switch (locale) {
            case 'cs': return 'Čeština';
            case 'en': return 'English';
            case 'bg': return 'български';
            case 'fr': return 'Français';
            case 'mn': return 'Монгол';
            case 'ph': return 'Filipino';
            case 'ro': return 'Română';
            case 'uk': return 'Yкраїнський';
            case 'ru': return 'Pусский';
            case LocalizationService.XX_LOCALE: return '[-??-]';
        }
        throw `Locale ${locale} is not supported`;
    }
}
LocalizationService.FALLBACK_LOCALE = 'cs';
LocalizationService.XX_LOCALE = 'xx';
